import { Button, Modal } from "antd";

export interface ConfirmFontUploadModalProps {
  isVisible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export function ConfirmFontUploadModal({
  isVisible,
  onCancel,
  onConfirm,
  isLoading,
}: ConfirmFontUploadModalProps) {
  return (
    <Modal
      className={"clean one"}
      onCancel={() => onCancel()}
      visible={isVisible}
    >
      <header>
        <h2>Add your fonts</h2>
      </header>

      <p>Please confirm that you have the necessary rights and licenses to allow us to modify and store the fonts.</p>

      <footer>
        <Button size={"large"} onClick={() => onCancel()}>
          Cancel
        </Button>
        <Button size={"large"} className={"primary"} onClick={onConfirm} loading={isLoading}>
          Yes, I do
        </Button>
      </footer>
    </Modal>
  );
}
